import { DeliveryState } from '../Models';

export type StateMapping = Record<DeliveryState, string>;
export const stateMapping: StateMapping = {
    estimated: 'Programado',
    requested: 'Solicitado y buscando rider',
    on_route_to_pickup: 'En ruta a farmacia',
    at_pickup: 'En farmacia',
    on_route_to_dropoff: 'En ruta a punto de entrega',
    at_dropoff: 'En punto de entrega',
    delivered_at_dropoff: 'Entregado',
    returning_to_pickup: 'Retornando a la farmacia',
    returned_to_pickup: 'En la farmacia',
    delivered_at_pickup: 'Entregado en la farmacia',
    archived: 'Finalizado',
    // Problemas
    internal_cancel: 'Cancelado',
    incident: 'Incidente',
    returning: 'Retornando por incidente',
    returned: 'Retornado por incidente',
    courier_canceled: 'Cancelado por cadete',
    pickup_failed: 'No se pudo recolectar',
};
